
import wmtDate from '@/utils/date.js'

class FormValite {
  /**
   * 处理parentKey 值相同的参数，相同的情况下先删除在push
   * arr 原始数据
   * item 需要新增替换的数据
   * flag 有值的时候删除当前parentKey
   * */
  handleParentKeyOnly(arr, item, flag) {
    if (item.length == 0 && flag) {
      let deleteIndex = arr.findIndex((v) => v.parentKey == flag);
      deleteIndex == -1 ? "" : arr.splice(deleteIndex, 1);
    } else {
      let nowParentKey = item[0].parentKey;
      let nowKeyIndex = arr.findIndex((v) => v.parentKey == nowParentKey);
      if (nowKeyIndex > -1) {
        arr.splice(nowKeyIndex, 1);
        arr.push(item[0]);
      } else {
        arr.push(item[0]);
      }
    }
    return arr;
  }

  /**
   * 重置 其他输入框的显示与展示
   * showFlag true 展示输入框 false 隐藏输入框，重置input
   * */
  resetOtherStatus(arr, showFlag) {
    for (let val of arr) {
      if (val.type == "other" && showFlag) {
        val.showInp = true;
        val.otherWord = "";
      } else {
        val.showInp = false;
      }
    }
    return arr;
  }

  /**
   * form 表单自定义字段组装拼接
   * */
  handleFormAttendKey(attentFormDtos, arr) {
    for (let val of arr) {
      let obj = {};
      // 单选框
      if (val.type == "radio") {
        obj.formContent = this.getValueByKey(val.child, val.value);
        obj.formTitle = val.label;
        obj.type = "RADIO";
      }

      // 输入框
      if (val.type == "input") {
        obj.formContent = val.value;
        obj.formTitle = val.label;
        obj.type = "TEXT";
      }

      // 输入框
      if (val.type == "textarea") {
        obj.formContent = val.value;
        obj.formTitle = val.label;
        obj.type = "TEXT";
      }

      if (val.type == "checkBox") {
        let otherIndex = val.valueName.findIndex((v) => v == "其他");
        if (otherIndex >= 0) {
          val.valueName[otherIndex] = val.otherWord;
        }
        obj.formContent = val.valueName.join(",");
        // obj.formContent = val.value
        obj.formTitle = val.label;
        obj.type = "CHECKBOX";
      }

      attentFormDtos.push(obj);
    }
    return attentFormDtos;
  }

  /**
   * form 表单自定义字段组装拼接带索引
   * */
  handleFormAttendKeyHasSort(attentFormDtos, arr) {
    for (let [index, val] of arr.entries()) {
      console.log(val);
      let obj = {};
      // 单选框
      if (val.type == "radio") {
        obj.formContent = this.getValueByKey(val.child, val.value);
        obj.formTitle = val.label;
        obj.type = "RADIO";
        obj.sort = index;
        if (val.isHealthQA) {
          obj.isHealth = true;
        }
      }

      // 输入框
      if (val.type == "input") {
        obj.formContent = val.isNumber ? Number(val.value) : val.value;
        obj.formTitle = val.label;
        obj.type = "TEXT";
        obj.sort = index;
        if (val.isHealthQA) {
          obj.isHealth = true;
        }
        if (val.isNumber) {
          obj.isNumber = true;
        }
      }

      // 输入框
      if (val.type == "textarea") {
        obj.formContent = val.value;
        obj.formTitle = val.label;
        obj.type = "TEXT";
        obj.sort = index;
        if (val.isHealthQA) {
          obj.isHealth = true;
        }
      }

      if (val.type == "checkBox") {
        let otherIndex = val.valueName.findIndex((v) => v == "其他");
        if (otherIndex >= 0) {
          val.valueName[otherIndex] = val.otherWord;
        }
        obj.formContent = val.valueName.join(",");
        // obj.formContent = val.value
        obj.formTitle = val.label;
        obj.type = "CHECKBOX";
        obj.sort = index;
        if (val.isHealthQA) {
          obj.isHealth = true;
        }
      }

      attentFormDtos.push(obj);
    }
    return attentFormDtos;
  }

  /**
   * form 表单自定义问卷组装拼接
   * */
  handleFormAttendKeyByQuestion(attentFormDtos, arr) {
    for (let val of arr) {
      let obj = {};
      // 单选框
      if (val.type == "radio") {
        obj.questionValue = this.getValueByKey(val.child, val.value);
        obj.questionName = val.label;
        obj.type = "RADIO";
      }

      // 输入框
      if (val.type == "input" || val.type == "select") {
        obj.questionValue = val.value;
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      // 输入框
      if (val.type == "textarea") {
        obj.questionValue = val.value;
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      // 单选确认同意条款框
      if (val.type == "singleCheck") {
        obj.questionValue = "是";
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      if (val.type == "checkBox") {
        let otherIndex = val.valueName.findIndex((v) => v == "其他");
        if (otherIndex >= 0) {
          val.valueName[otherIndex] = val.otherWord;
        }
        obj.questionValue = val.valueName.join(",");
        obj.questionName = val.label;
        obj.type = "CHECKBOX";
      }

      attentFormDtos.push(obj);
    }
    return attentFormDtos;
  }

  // 处理健康承诺书提交信息
  handleHealthData(attentFormDtos, arr) {
    for (let val of arr) {
      let obj = {};
      // 单选框
      if (val.type == "radio") {
        obj = {
          checkDetailBeans: [
            {
              checkBox: true,
              remark: "",
              value: "",
            },
          ],
          title: val.label,
        };
        if (val.isHealth) {
          obj.checkDetailBeans[0].value = this.getValueByKey(
            val.child,
            val.value
          );
          obj.checkDetailBeans[0].remark = "";
        } else {
          obj.checkDetailBeans[0].value = "";
          obj.checkDetailBeans[0].remark = this.getValueByKey(
            val.child,
            val.value
          );
        }
      }

      // 输入框
      // if (val.type == "input") {
      //   obj = {
      //     checkDetailBeans: [{
      //       checkBox: true,
      //       remark: '',
      //       value: val.value
      //     }],
      //     title: val.label
      //   };
      // }

      // // 输入框
      // if (val.type == "textarea") {
      //   obj = {
      //     checkDetailBeans: [{
      //       checkBox: true,
      //       remark: '',
      //       value: val.value
      //     }],
      //     title: val.label
      //   };
      // }

      // 单选确认同意条款框
      if (val.type == "singleCheck") {
        console.log("我进来了");
        obj = {
          checkDetailBeans: [
            {
              checkBox: true,
              remark: "",
              value: "",
            },
          ],
          title: val.label,
        };
        if (val.isHealth) {
          obj.checkDetailBeans[0].value = "是";
        } else {
          obj.checkDetailBeans[0].value = "是";
        }
      }

      if (val.type == "checkBox") {
        let otherIndex = val.valueName.findIndex((v) => v == "其他");
        if (otherIndex >= 0) {
          val.valueName[otherIndex] = val.otherWord;
        }

        obj = {
          checkDetailBeans: [
            {
              checkBox: true,
              remark: "",
              value: val.valueName.join(","),
            },
          ],
          title: val.label,
        };

        if (val.isHealth) {
          obj.checkDetailBeans[0].value = val.valueName.join(",");
          obj.checkDetailBeans[0].remark = "";
        } else {
          obj.checkDetailBeans[0].value = "";
          obj.checkDetailBeans[0].remark = val.valueName.join(",");
        }
      }

      // if (val.type != "singleCheck") {
      // }

      attentFormDtos.push(obj);
    }
    return attentFormDtos;
  }

  /**
   * 根据key值返回name
   * */
  getValueByKey(arr, key) {
    let labelArr = arr.filter((v) => v.key == key);
    return labelArr[0].type == "other"
      ? labelArr[0].otherWord
      : labelArr[0].label;
  }

  // 后台搭建表单
  handleFormAttendKeyByQuestionByNew(attentFormDtos, arr) {
    for (let val of arr) {
      let obj = {};
      // 单选框
      if (val.type == "radio") {
        let otherFlag = val.value == "其他";
        if (otherFlag) {
          val.value = val.otherWord;
        }
        obj.questionValue = val.value;
        obj.questionName = val.label;
        obj.type = "RADIO";
      }

      // 输入框
      if (
        val.type == "input" ||
        val.type == "select" ||
        val.type == "numberInput" ||
        val.type == "exh_customized" ||
        val.type == "group_customized" ||
        val.type == "textarea"
      ) {
        obj.questionValue = val.value;
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      // 单选确认同意条款框
      if (val.type == "singleCheck") {
        obj.questionValue = "是";
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      if (val.type == "timePicker") {
        obj.questionValue = wmtDate.fromatDate('yyyy/MM/dd', new Date(val.value));
        obj.questionName = val.label;
        obj.type = "TEXT";
      }

      if (val.type == "checkBox") {
        let otherIndex = val.value.findIndex((v) => v == "其他");
        if (otherIndex >= 0) {
          val.value[otherIndex] = val.otherWord;
        }
        obj.questionValue = val.value.join(",");
        obj.questionName = val.label;
        obj.type = "CHECKBOX";
      }

      attentFormDtos.push(obj);
    }
    return attentFormDtos;
  }
}

const formValite = new FormValite();

export default formValite;
